var React = require('react');

function Autosave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.885 0 14 3.613V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h7.885ZM9 1.5H2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V5.131H10a1 1 0 0 1-.993-.883L9 4.132V1.5Zm1.801 5.702a.67.67 0 0 0-.814-.112l-.144.112-3.792 3.85L4.157 9.13a.67.67 0 0 0-.958 0 .697.697 0 0 0-.11.826l.11.147L6.05 13l4.75-4.825a.696.696 0 0 0 0-.973Z","fill":"#0C1014","fillRule":"evenodd"}));
}

Autosave.defaultProps = {"viewBox":"0 0 14 16","width":"14","height":"16"};

module.exports = Autosave;

Autosave.default = Autosave;
